export default "__VITE_ASSET__DvFHdNza__"